import { Link, Stack } from '@mui/material'
import { useSelector } from 'react-redux'
import { Security, Instrument } from '../../proto/generated/security'
import { OverviewWidgetResponse_IndexComponent } from '../../proto/generated/overview-widget'
import { RootState } from '../../store'
import useOverviewPanelNavigation from '../../hooks/useOverviewPanelNavigation'
import IndexComponents from './IndexComponents'

type Props = {
    indexComponents: OverviewWidgetResponse_IndexComponent[]
    security: Security | undefined
}

const isIndexSecurity = (security: Security | undefined) =>
    security?.instrument === 'IDX' || security?.instrument === Instrument.IDX

const IndexComponentsSection = ({ indexComponents, security }: Props) => {
    const openComponentsPage = useOverviewPanelNavigation('components')
    const totalCount = useSelector((state: RootState) => state.overviewStore.indexComponentTotalCount)
    const hasContribution = useSelector((state: RootState) => state.overviewStore.hasIndexContribution)

    if (!isIndexSecurity(security) || indexComponents.length === 0) {
        return null
    }

    const showSeeAll = !hasContribution && totalCount > indexComponents.length

    return (
        <>
            <IndexComponents
                indexComponents={indexComponents}
                showContribution={hasContribution}
            />
            {showSeeAll && (
                <Stack direction="row-reverse" sx={{ mx: 0.5, mb: 0.5 }}>
                    <Link
                        color="primary"
                        underline="hover"
                        variant="caption"
                        sx={{ fontWeight: 400, cursor: 'pointer' }}
                        onClick={() => openComponentsPage(security)}
                    >
                        {`See all ${totalCount} components`}
                    </Link>
                </Stack>
            )}
        </>
    )
}

export default IndexComponentsSection
